export enum GACategory {
  timeline = "Ask Ida"
}

export enum GAActions {
  openTrackerDialog = "Open Ask Ida tracker in dialog",
  createTracker = "Create Ask Ida Tracker",
  startCreateTrackerWizard = "Start the Create Ask Ida Tracker Wizard",
  addKPI = "Add KPI to track",
  removeKPI = "Remove KPI from tracking",
  changeExpectedDirection = "Change expected KPI direction",
  changeDate = "Change expected tracking end date"
}
